
import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils'; // Updated import to get token from 
import { getRequest, postRequest } from '../../config/AxiosConfig';
const apiBaseUrl = API_URLS.CUSTOMER; 

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

//Get Profile Data
export const fetchProfile = async (onAfterRequest = () => {}) => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + "profile",
      headers: getAuthHeaders(), 
       onAfterRequest,
    });
  
    return response;
  } catch (error) {
    console.error('Error fetching profile:', error.response?.data || error.message);
    throw error;
  }
};


//Get Wallet/Payout   or Balance Data
export const fetchBalanceAll = async ({account_type}) => {
  try {
    const payload = {
      "account_type":account_type
    };
    const response = await postRequest({
      url: apiBaseUrl + "fetch-balance",
      headers: getAuthHeaders(),
      data: payload 
      
    });
   
    return response;
  } catch (error) {
    console.error('Error fetching Bal:', error.response?.data || error.message);
    throw error;
  }
};



// Update Password in Profile Page
export const updatePassword = async ({ current_password, new_password, new_password_confirmation }) => {
  try {
    const payload = {
      current_password,
      new_password,
      new_password_confirmation,
    };
    const response = await postRequest({
      url: apiBaseUrl + "update-password",
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error updating password:', error.response?.data || error.message);
    throw error;
  }
};
// End Password

// Update PIN in Profile Page
export const updatePin = async ({ current_pin, new_pin, new_pin_confirmation }) => {
  try {
    const payload = {
      current_pin,
      new_pin,
      new_pin_confirmation,
    };
    const response = await postRequest({
      url: apiBaseUrl + "update-pin",
      headers: getAuthHeaders(), 
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error updating PIN:', error.response?.data || error.message);
    throw error;
  }
};
// End Pin



// Verify Pan Service Digital KYC
export const verifyPanService = async () => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + "validate-pan",
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    console.error('Error Verify Pan:', error.response?.data || error.message);
    throw error;
  }

}



// Verify Pan Service SignUp
export const verifyPanSignUpService = async ({pan_number}) => {
  try {
    const payload = {pan_number};
    const response = await postRequest({
      url: apiBaseUrl + "validate-pan",
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error Verify Pan:', error.response?.data || error.message);
    throw error;
  }

}


// Verify Company Pan Service SignUp
export const verifyCompanyPanSignUpService = async ({company_pan}) => {
  try {
    const payload = {company_pan};
    const response = await postRequest({
      url: apiBaseUrl + "validate/company-pan",
      headers: getAuthHeaders(),
      data: payload,
    });
    console.log("Company Pan Verify Response:", response);
    return response;
  } catch (error) {
    console.error('Error Verify company Pan:', error.response?.data || error.message);
    throw error;
  }

}


  // User Type Check Service
export const UserTypeCheckService = async ({type}) => {
  try {
    const payload = {type};
    const response = await postRequest({
      url: apiBaseUrl + "registration-type",
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error in User Type Check:', error.response?.data || error.message);
    throw error;
  }
};


// Verify Aadhar Service Digital KYC
export const aadharverifyPService = async () => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + "validate-aadhar",
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    console.error('Error in Verify aadhar:', error.response?.data || error.message);
    throw error;
  }
};



// Verify Aadhar SignUP
export const aadharverifySignUpService = async ({ aadhar_number }) => {
  try {
    const payload = {aadhar_number};
    const response = await postRequest({
      url: apiBaseUrl + "validate-aadhar",
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error in Verify aadhar:', error.response?.data || error.message);
    throw error;
  }
};


// Verify Aadhar OTP Service SignUP
export const verifyaADHAROtpSignUP = async ({ clientId, otp }) => {
  try {
    const payload = {
      'client_id': clientId,
        'otp': otp
    };
    const response = await postRequest({
      url: apiBaseUrl + "validate-aadhar-auth",
      headers: getAuthHeaders(), 
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error Verify otp:', error.response?.data || error.message);
    throw error;
  }
};



// Verify Aadhar OTP Service Digital KYC
export const verifyaADHAROtp = async ({ clientId, otp }) => {
  try {
    const payload = {
      'client_id': clientId,
        'otp': otp
    };
    const response = await postRequest({
      url: apiBaseUrl + "validate-aadhar-auth",
      headers: getAuthHeaders(), 
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error Verify otp:', error.response?.data || error.message);
    throw error;
  }
};

// verify Mobile No
export const verifyMobile = async () => {
  try {
    const response = await postRequest({
   url: apiBaseUrl + "validate-mobile",
   headers: getAuthHeaders()
    });
    return(response);
  } catch (error) {
    console.error('Error in Verify Mobile no', error.response?.data || error.message);
    throw error;
  }
};

//Verify Mobile OTP
export const verifyMobileOtp = async ({ identifier, otp}) => {
  try {
    const payload = {
      'identifier' : identifier,
      'otp' : otp
    };
    const response = await postRequest({
      url: apiBaseUrl + "validate-mobile-auth",
      headers: getAuthHeaders(),
      data: payload,
    });
    return(response);
  } catch (error) {
    console.error('Error in Verify  Otp:', error.response?.data || error.message);
    throw error;
  }
};

  // Verify Email ID
export const verifyEmail = async () => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + "validate-email",
      headers: getAuthHeaders()
    });
    return(response);
  } catch (error) {
    console.error('Error in Verify Email', error.response?.data || error.message);
    throw error;
  }
};



// verify Mobile No SignUp
export const verifyMobileSignUp = async () => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + "validate-mobile",
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    console.error('Error verifying Mobile Number:', error.response?.data || error.message);
    throw error;
  }
};


//Verify Mobile OTP SignUp
export const verifyMobileOtpSignUp = async ({ identifier, otp}) => {
  try {
    const payload = {
      'identifier' : identifier,
      'otp' : otp
    };
    const response = await postRequest({
      url: apiBaseUrl + "validate-mobile-auth",
      headers: getAuthHeaders(),
      data: payload,
    });
    return(response);
  } catch (error) {
    console.error('Error in Verify  Otp:', error.response?.data || error.message);
    throw error;
  }
};



  // Verify Email SignUp
export const verifyEmailSignUp = async () => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + "validate-email",
      headers: getAuthHeaders(),
    });
    return(response);
  } catch (error) {
    console.error('Error in Verify Email', error.response?.data || error.message);
    throw error;
  }
};

  //Verify Email OTP SignUp
export const verifyEmailOtp = async ({ identifier, otp}) => {
  try {
    const payload = {
      'identifier' : identifier,
      'otp' : otp
    };
    const response = await postRequest({
      url: apiBaseUrl + "validate-email-auth",
      headers: getAuthHeaders(),
      data: payload,
    });
    return(response);
  } catch (error) {
    console.error('Error in Verify Email Otp:', error.response?.data || error.message);
    throw error;
  }
};






// Retrive Login Activity from API
export const retriveLoginActivityService = async (page = 1) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}login-activity?page=${page}`,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    console.error('Error fetching Login Activity data:', error.response?.data || error.message);
    throw error;
  }
};


     // Preview ProfileImg
export const profileImgPreview = async ({ filename }) => {
  try {
    const response = await getRequest({
      url: apiBaseUrl + `user-kyc-files/${filename}`,
      headers: getAuthHeaders() 
    });
    return response;
  } catch (error) {
    console.error("Error fetching image:", error.response?.data || error.message);
    throw error;
  }
};




export const NewsNotificationServices = async (page = 1) => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + `dashboard-news?page=${page}`,
      headers: getAuthHeaders()
    });
    return response;
  } catch (error) {
    console.error("Error fetching image", error.response?.data || error.message);
  }
};

export const NewsNotificationUpdateServices = async () => {
  try {
    const response = await postRequest({
      url: apiBaseUrl + `update-news-view-count`,
      headers: getAuthHeaders()
    });
    return response;
  } catch (error) {
    console.error("Error fetching image", error.response?.data || error.message);
  }
};
